import { CheckmarkCircle02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const RequestSentView = () => (
  <div className="flex flex-col items-center justify-center h-full p-6 text-center gap-4">
    <div className="p-5 bg-primary-20 rounded-full">
      <HugeiconsIcon
        icon={CheckmarkCircle02Icon}
        size={32}
        className="text-primary-500"
      />
    </div>

    <h2 className="text-xl font-bold text-content-1000">
      Request has been sent to the applicant
    </h2>
  </div>
);
